<template>
<div class="map-details">
	<grid flat>
		<grid-item size="1/2" class="key">Block:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				Offshore Z-38
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Main Prospect:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				To be identified
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Land Area:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				873.617 ha
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Depth:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				300m - 3000
			</span>
		</grid-item>
	</grid>
	<grid flat>
		<grid-item size="1/2" class="key">Land Allocation:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				Exploration License
			</span>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.map-details {
	text-align: left;
	color: #fff;
	font-size: 12px;
	font-weight: 200;
	padding-right: 16px;
	
	.key {
		font-weight: 500;
	}
	.value {
		display: flex;

		span {
			align-self: flex-end;
		}
	}
}
</style>
